import { render, staticRenderFns } from "./ProjectSearchModal.vue?vue&type=template&id=53af0c8e"
import script from "./ProjectSearchModal.vue?vue&type=script&lang=js"
export * from "./ProjectSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports